import React, { useRef, useState } from 'react';
import QRCode from 'qrcode.react';
import whatsapp from '../../assets/socalImages/whatsapp.svg'
import email from '../../assets/socalImages/email.svg'
import facebook from '../../assets/socalImages/facebook.svg'
import twitter from '../../assets/socalImages/twitter.svg'
import downloadIcon from '../../assets/socalImages/download-icon.svg'
import copyIcon from '../../assets/socalImages/copy-icon.svg'
import customToast from '../../components/common/basic/Toast';
import { baseUrl } from '../../config/config';
import { cutString } from '../../services/util';
import { dashboardColors, theme } from '../../themes/Theme';
const ShareModal = (props) => {
    const qrRef = useRef(null);

    const currentUrl = typeof window !== 'undefined' ? window.location.href : '';

    const copyToClipboard = () => {
        if (navigator.clipboard) {
            navigator.clipboard.writeText(eventUrl).then(() => {
                customToast.success("The URL has been copied");
            });
        }
    };
    const eventUrl = `${baseUrl}/${props?.props?.eventInfo?.
        event_url}`
    const downloadQRCode = () => {
        const canvas = qrRef.current?.querySelector('canvas');
        if (!canvas) return;

        const url = canvas.toDataURL('image/png');
        const a = document.createElement('a');
        a.href = url;
        a.download = 'qr-code.png';
        a.click();
    };

    const shareOptions = [
        {
            name: 'WhatsApp',
            icon: whatsapp,
            url: `https://api.whatsapp.com/send?text=${encodeURIComponent(eventUrl)}`
        },
        {
            name: 'Facebook',
            icon: facebook,
            url: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(eventUrl)}`
        },

        {
            name: 'X',
            icon: twitter,
            url: `https://twitter.com/intent/tweet?url=${encodeURIComponent(eventUrl)}`
        },
        {
            name: 'Email',
            icon: email,
            url: `mailto:?subject=Check this out&body=${encodeURIComponent(eventUrl)}`
        },
    ];

    return (
        <>
            <div className='d-flex flex-column richtext-gap-3'>
                <div className='d-flex mt-2 qr-cont-share-modal mb-2 richtext-flex-col richtext-gap-3 align-items-center justify-content-center'>
                    <div ref={qrRef}>   <QRCode
                        ref={qrRef}
                        value={eventUrl}
                        size={150}
                        bgColor="#ffffff"
                        fgColor="#000000"
                        level="H"
                    /></div>
                    <button
                        className='download-qr-code d-flex richtext-gap-2 align-items-center'
                        onClick={downloadQRCode}
                    >
                        Download 
                    </button>                </div>
                <p className='event-share-options mb-0'>Share</p>

                <div className="share-options d-flex richtext-gap-2 mt-1  richtext-justify-between ">
                    {shareOptions.map(app => (
                        <span
                            key={app.name}
                            className="share-option "
                            onClick={e => {
                                e.stopPropagation();
                                window.open(app.url, '_blank');
                            }}
                        >
                            <div className='d-flex richtext-flex-col richtext-gap-2 share-btn-cont richtext-align-middle align-items-center'>
                                <img src={app.icon} alt={app.name} className="share-option-icon-event" />
                                <span className="share-option-name">{app.name}</span>
                            </div>

                        </span>
                    ))}
                </div>

                <div className="share-copy-link">
                    <p className="event-share-options-txt my-2 mb-0">Copy Link</p>
                    <div className="share-copy-link-input d-flex">

                        {cutString(eventUrl, 29)}
                        <img onClick={e => {
                            e.stopPropagation();
                            copyToClipboard();
                        }} src={copyIcon} className='ml-2 cursor-pointer' alt="copyIcon" />
                    </div>
                </div>
            </div>
            <style jsx>
                {`
            
            .download-qr-code{
                border: 1px solid ${dashboardColors[theme].primary} ;
                border-radius: 2px;
                background-color: transparent;
                color:${dashboardColors[theme].primary};
                padding: 4px 16px;
                font-size:14px;
                font-weight:500;
            }
            .share-option-icon-event{
                 height:38px;
                 width:38px;   
            }
            .event-share-options-txt{
                    font-size:14px;
                    font-weight:500;
                    color:#333333;
            }
            .share-option-name {
                    font-size:10px;
                    font-weight:400;
                    color:#333333;
            }
            .share-btn-cont{
                width:60px;
                height:60px;
                cursor:pointer;
            }
            .cursor-pointer{
                    cursor:pointer;
            }
            .qr-cont-share-modal{
                    border: 2px solid #002E6E;
                    border-radius:4px;
                    padding:30px;
            }
            .share-copy-link-input{
                    border-radius:2px;
                    border: 0.5px solid #C3CDDF;
                    padding:16px 10px;
                    justify-content: space-between;
                }
            `}
            </style>
        </>
    );
};

export default ShareModal;
